import { QueryClient } from "@tanstack/react-query";

// Cache condivisa delle risposte API (react-query): usata dal provider in index.js e da api.js (fetchQuery)
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});
